import React from "react";
import Colors from "../../constants/Colors";
import { numberToPixels } from "../../lib/StringHelper";

const DETECTOR_STROKE = 2;

interface DetectionBox {
  name: string;
  screenStyles: React.CSSProperties;
}

const detectionStyle = (selected: boolean) => {
  let width = selected ? 2 * DETECTOR_STROKE : DETECTOR_STROKE;
  let borderString = `${numberToPixels(width)} solid`;
  borderString += ` ${Colors.primary}`;
  return {
    border: borderString,
    ...styles.detections,
  };
};

const DetectionBox = (props: DetectionBox) => {
  const { name, screenStyles } = props;
  const computedStyle = {
    ...detectionStyle(false),
    ...screenStyles,
  };
  return (
    <div style={computedStyle}>
      <div style={styles.detectionTextContainer}>
        <p style={styles.detectionText}>{name}</p>
      </div>
    </div>
  );
};

const styles = {
  detectionTextContainer: {
    position: "relative" as const,
    backgroundColor: Colors.primary,
    top: 0,
    left: 0,
    marginTop: "-0.7rem",
    marginLeft: numberToPixels(-1 * DETECTOR_STROKE),
    marginRight: numberToPixels(-1 * DETECTOR_STROKE),
  },
  detectionText: {
    marginTop: 0,
    marginBottom: 0,
    marginRight: 0,
    marginLeft: numberToPixels(DETECTOR_STROKE),
    fontSize: "0.7rem",
    lineHeight: "0.7rem",
    color: Colors.white,
    textOverflow: "ellipses",
    whiteSpace: "nowrap" as const,
  },
  detections: {
    position: "absolute" as const,
    zIndex: 2,
  },
};

export default DetectionBox;
